import React, { Suspense, lazy } from 'react';
import { useIsMobile } from '@/hooks/use-media-query';
import { useAuth } from '@/contexts/AuthContext';
import MobileCRM from '@/pages/mobile/MobileCRM';

// Task #1748 — refactor strutturale: CRM.tsx (10.5k LOC) spaccato in feature-module
// sotto `pages/crm/`. CRMDesktop resta il body principale (importa i feature-module
// estratti: shared/, leads/, kanban/, appointments/). Caricato lazy per ridurre il
// bundle iniziale quando il device è mobile (renderizza MobileCRM senza payload desktop).
const CRMDesktop = lazy(() => import('./CRMDesktop'));

export default function CRM() {
  const isMobile = useIsMobile();
  const { user } = useAuth();
  // Task #3774 — confine di identità: TUTTO lo stato CRM (dataset condivisi
  // alla radice, selezioni, modali, stati per-tab retained) vive sotto questo
  // componente keyed su `tenantId:userId`. Al cambio identità nella stessa SPA
  // (logout/login di un altro utente, cambio tenant, impersonificazione) React
  // smonta e rimonta l'intera pagina: nessun dato dell'identità precedente può
  // restare visibile né ripopolare cache/retention. Non spostare stato CRM
  // sopra questo confine.
  const identityKey = `${user?.tenantId ?? ''}:${user?.id ?? ''}`;
  if (isMobile) return <MobileCRM key={identityKey} />;
  return (
    <Suspense fallback={<div className="p-8 text-center text-muted-foreground">Caricamento CRM…</div>}>
      <CRMDesktop key={identityKey} />
    </Suspense>
  );
}
